(() => {
  const KEY = "ls_wishlist_v1";
  const LIST_ID = "LsWishlistDrawerList";

  const read = () => {
    try { return JSON.parse(localStorage.getItem(KEY) || "[]"); }
    catch(e){ return []; }
  };

  const money = (cents) => {
    const v = (Number(cents) || 0) / 100;
    // Keep it simple + consistent with your site currency later if needed
    return `£${v.toFixed(2)}`;
  };

  const fetchProduct = async (handle) => {
    const res = await fetch(`/products/${encodeURIComponent(handle)}.js`, {
      credentials: "same-origin",
      headers: { Accept: "application/json" }
    });
    if (!res.ok) throw new Error(`fetch failed: ${handle}`);
    return res.json();
  };

  const addToCart = async (variantId) => {
    const res = await fetch(`/cart/add.js`, {
      method: "POST",
      credentials: "same-origin",
      headers: { "Content-Type": "application/json", Accept: "application/json" },
      body: JSON.stringify({ id: Number(variantId), quantity: 1 })
    });
    if (!res.ok) throw new Error("add to cart failed");
    return res.json();
  };

  const removeHandle = (handle) => {
    const list = read();
    const i = list.indexOf(handle);
    if (i >= 0) list.splice(i, 1);
    localStorage.setItem(KEY, JSON.stringify(list));
    window.dispatchEvent(new CustomEvent("ls:wishlist-changed", { detail: { list }}));
  };

  const renderItem = (prod) => {
    const url = `/products/${prod.handle}`;
    const img = prod.featured_image || (prod.images && prod.images[0]) || "";
    const v = (prod.variants || []).find(x => x.available) || (prod.variants || [])[0];
    const variantId = v?.id;
    const soldOut = !v?.available;

    return `
      <div class="ls-wi" data-handle="${prod.handle}">
        <a class="ls-wi__media" href="${url}">
          ${img ? `<img class="ls-wi__img" src="${img}" alt="${prod.title}" loading="lazy">` : ``}
        </a>

        <div class="ls-wi__meta">
          <a class="ls-wi__title" href="${url}">${prod.title}</a>
          <div class="ls-wi__price">${money(v?.price ?? prod.price)}</div>

          <div class="ls-wi__actions">
            <button class="ls-wi__remove button-secondary" type="button" data-ls-wi-remove>
              Remove
            </button>

            <button
              class="ls-wi__add button"
              type="button"
              ${(!variantId || soldOut) ? "disabled" : ""}
              data-ls-wi-add="${variantId || ""}"
            >
              ${soldOut ? "Sold out" : "Add to cart"}
            </button>
          </div>
        </div>
      </div>
    `;
  };

  const render = async () => {
    const el = document.getElementById(LIST_ID);
    if (!el) return;

    const handles = read();

    if (!handles.length) {
      el.innerHTML = "";
      return;
    }

    el.innerHTML = `<div class="ls-wi__loading">Loading…</div>`;

    try {
      const prods = await Promise.all(handles.slice(0, 12).map(fetchProduct));
      el.innerHTML = prods.map(renderItem).join("");
    } catch (e) {
      console.error("[ls-wishlist-drawer] render error:", e);
      el.innerHTML = `<div class="ls-wi__loading">Couldn’t load favourites.</div>`;
    }
  };

  // Click handlers inside the popover list
  document.addEventListener("click", async (e) => {
    const item = e.target.closest(".ls-wi");
    if (!item) return;

    // Remove
    if (e.target.closest("[data-ls-wi-remove]")) {
      e.preventDefault();
      e.stopPropagation();
      removeHandle(item.dataset.handle);
      return;
    }

    // Quick add
    const addBtn = e.target.closest("[data-ls-wi-add]");
    if (addBtn) {
      e.preventDefault();
      e.stopPropagation();

      const variantId = addBtn.getAttribute("data-ls-wi-add");
      if (!variantId) return;

      addBtn.disabled = true;
      const prev = addBtn.textContent;
      addBtn.textContent = "Adding…";

      try {
        await addToCart(variantId);
        addBtn.textContent = "Added ✓";
      } catch (err) {
        console.error(err);
        addBtn.textContent = "Error";
      } finally {
        setTimeout(() => {
          addBtn.textContent = prev;
          addBtn.disabled = false;
        }, 900);
      }
    }
  }, { passive: false });

  document.addEventListener("DOMContentLoaded", render);
  document.addEventListener("shopify:section:load", render);
  window.addEventListener("ls:wishlist-changed", render);

  window.addEventListener("pageshow", render);

document.addEventListener("click", (e) => {
  if (e.target.closest(".wishlist-popover")) {
    setTimeout(render, 50);
  }
});

  // optional: allow manual debug in console
  window.LS_WISHLIST_DRAWER = { render };
})();